import { render } from "./CertificateAboutPage.vue?vue&type=template&id=5fa8d79e&scoped=true"
import script from "./CertificateAboutPage.vue?vue&type=script&lang=js"
export * from "./CertificateAboutPage.vue?vue&type=script&lang=js"

import "./CertificateAboutPage.vue?vue&type=style&index=0&id=5fa8d79e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa8d79e"]])

export default __exports__